import type { Meta, StoryObj } from "@storybook/react";

import { fakeContactInfoSectionProps } from "@/__mocks__/profile/overview";
import type { ContactInfoSectionProps } from "@/ui/components/profile";
import { ContactInfoSection } from "@/ui/components/profile";
import { Box } from "@/ui/layout";
import type {
  Permission,
  UserPermissionsType,
} from "@/utils/profile/permissions.util";
import {
  getPermissionChecker,
  UserPermissionsTypes,
} from "@/utils/profile/permissions.util";

const AllPermissions = "all";

const StoryMeta: Meta<
  { permissionsProfile: "all" | UserPermissionsType } & ContactInfoSectionProps
> = {
  title: "Components/Profile/Contact Info",
  component: ContactInfoSection,
  argTypes: {
    addressLine1: { control: "text" },
    addressLine2: { control: "text" },
    cellPhone: { control: "text" },
    city: { control: "text" },
    contactPreferences: { control: "object" },
    email: { control: "text" },
    permissionsProfile: {
      control: "select",
      options: [...Object.keys(UserPermissionsTypes), AllPermissions],
    },
    state: { control: "text" },
    zip: { control: "text" },
  },
  args: {
    ...fakeContactInfoSectionProps(),
    permissionsProfile: AllPermissions,
  },
  render: (props) => {
    const { permissionsProfile } = props;
    const userPermissions =
      permissionsProfile === AllPermissions
        ? (): Permission => "editAndView"
        : getPermissionChecker(UserPermissionsTypes[permissionsProfile]);

    return (
      <Box width="100%">
        <ContactInfoSection {...props} userPermissions={userPermissions} />
      </Box>
    );
  },
};

type Story = StoryObj<ContactInfoSectionProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
